export const colors = {
  brandSecondaryDefault: "#75EBD2",
  brandSecondaryTint: "#D4FAF2",
  brandSecondaryShade: "#004435",
  brandGradientDefault: "linear-gradient(125deg, #00E5B4 0%, #0070EB 100%)",
  brandGradientColorStopsStart: "#00E5B4",
  brandGradientColorStopsEnd: "#0070EB",
  contentBrandSecondary: "#75EBD2",
};

export const text = {
  themeName: "FaceOff Light",
};